var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseLeftBar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8722 2.41421L2.56316 6.70711C2.17117 7.09763 1.53563 7.09763 1.14363 6.70711C0.751642 6.31658 0.751642 5.68342 1.14363 5.29289L6.16243 0.292893C6.55442 -0.0976311 7.18997 -0.0976311 7.58196 0.292893L12.6008 5.29289C12.9928 5.68342 12.9928 6.31658 12.6008 6.70711C12.2088 7.09763 11.5732 7.09763 11.1812 6.70711L6.8722 2.41421Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLeftBar);
export default __webpack_public_path__ + "static/media/close-left-bar.990ba922b709c37f3b7f09f8831362fc.svg";
export { ForwardRef as ReactComponent };